const topics = [
  { label: '#2026暑期档', hot: true, count: '128万讨论' },
  { label: '#国产剧崛起', hot: true, count: '96万讨论' },
  { label: '#悬疑片推荐', hot: false, count: '83万讨论' },
  { label: '#经典重温', hot: false, count: '67万讨论' },
  { label: '#动画电影', hot: true, count: '55万讨论' },
  { label: '#纪录片推荐', hot: false, count: '42万讨论' },
  { label: '#韩剧热播', hot: true, count: '118万讨论' },
  { label: '#美剧新季', hot: false, count: '73万讨论' },
  { label: '#电影解说', hot: true, count: '91万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-3">
            热门话题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            大家都在讨论
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl mx-auto">
            影视社区热门话题，加入讨论分享你的观影见解
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#comments"
              className="inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 bg-background-100 border border-background-200/60 rounded-full hover:border-primary-500/20 hover:bg-background-200/50 transition-all duration-300 cursor-pointer no-underline group"
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-fill text-sm text-primary-400"></i>
                </span>
              )}
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}